var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopSpinning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0PY2k74qFM1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 26",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.441189 0.200194)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "e0PY2k74qFM4",
    transform: "matrix(0-1 1 0 0.592615 26.289763)",
    mask: "url(#e0PY2k74qFM6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4412,12.7998c0,6.9036-.000027,12.5,0,12.5-6.9036,0-12.500038-5.5964-12.500038-12.5s12.500038-12.499995,12.500038-12.499995s0,5.596445,0,12.499995Zm-10.00004,0c0,5.5229,10.00004,10,10.00004,10s-.000027-4.4771-.000027-10s.000027-10,.000027-10-10.00004,4.47716-10.00004,10Z",
    transform: "matrix(0 1-1 0 26.240992-.543835)",
    fill: "none",
    stroke: "#b7844d",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e0PY2k74qFM6",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9412,12.7998c0,6.9036-5.5965,12.5-12.5,12.5-6.9036,0-12.500038-5.5964-12.500038-12.5s5.596438-12.499995,12.500038-12.499995s12.5,5.596445,12.5,12.499995Zm-22.50004,0c0,5.5229,4.47715,10,10.00004,10s10-4.4771,10-10-4.4772-10-10-10-10.00004,4.47716-10.00004,10Z",
    fill: "#fff"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.727289,
    height: 10.143726,
    rx: 0,
    ry: 0,
    transform: "matrix(.932202 0 0 0.985831 7.969693 8.010531)",
    fill: "#b7844d",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSpinning);
export default __webpack_public_path__ + "static/media/Stop-spinning.b11021716c5d5d51e176c5b4c20eef9c.svg";
export { ForwardRef as ReactComponent };